import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import ProChioseTree from "@/components/pro-common/pro-chiose-modal/pro-chiose-tree.vue";
export default {
  name: "pro-chiose-tab-structure",
  components: {
    ProChioseTree
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    treeData: {
      type: Array,
      default() {
        return [];
      }
    },
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    _treeData() {
      let treeData = JSON.parse(JSON.stringify(this.treeData));
      this.DG(treeData, true);
      return treeData;
    }
  },
  methods: {
    DG(treeData, boo) {
      treeData.forEach(v => {
        v.expand = boo || false;
        v.disabled = true;
        if (v.userId) {
          v.name = v.userName;
        }
        v.children = [...(v.children || []), ...(v.organizationUsers || [])];
        if (v.children && v.children.length > 0) {
          this.DG(v.children);
        }
      });
    },
    /*
     * 清空
     */
    clearAll() {
      let dg = arr => {
        arr.forEach(v => {
          v.isCheck = false;
          if (v.children && v.children.length > 0) {
            dg(v.children);
          }
        });
      };
      dg(this._treeData);
    },
    /*
     * 清空一个
     */
    clearOne(item) {
      if (item.userId) {
        let dg = (arr, i) => {
          arr.forEach(v => {
            if (v.userId === i.userId) {
              v.isCheck = false;
            }
            if (v.children && v.children.length > 0) {
              dg(v.children, i);
            }
          });
        };
        dg(this._treeData, item);
      }
    },
    onChange(item) {
      let checkedList = [...this.value];
      if (item.isCheck) {
        checkedList.unshift(item);
      } else {
        checkedList = checkedList.filter(v => {
          if (item.orgId) {
            return v.orgId !== item.orgId;
          } else {
            return v.userId !== item.userId;
          }
        });
      }
      this.$emit("input", checkedList);
    }
  }
};